{
  "explain_version" : "1.25.6",
  "display_update_modal": true,
  "__comment__": "le module specifique prend les valeurs, '', 'tenders', ou 'territory_intel'. Si la valeur est '' cela signifie que l'on affiche la modale pour tous les modules",
  "target_update_modal_module": "",

  "__comment__": "__choose the feature to highlight and display its feature modal, set in features-config.ts__",
  "highlight_feature": "",

  "other": "0"
}
